import Vue from 'vue'
import Router from 'vue-router'
import Index from '../view/index'
import List from '../view/list'
import Article from '../view/article'
import Search from '../view/search'
import basicInfo from '../view/basicInfo'
import stuInfoing from '../view/stuInfoing'


Vue.use(Router); 

const router = new Router( {
  routes:[ {
      path:'/', 
      redirect:'/index'
    },  {
      path:'/index', 
      name:'Index', 
      component:Index, 
      meta: {requiresAuth:false }
    },  {
      path:'/list/:cid', 
      name:'list', 
      component:List, 
      meta: {requiresAuth:false }
    },  {
      path:'/search/:sid', 
      name:'search', 
      component:Search, 
      meta: {requiresAuth:false }
    },  {
      path:'/article/:cid/:aid', 
      name:'article', 
      component:Article, 
      meta: {requiresAuth:false }
    },  {
      path:'/basicInfo', 
      name:'basicInfo', 
      component:basicInfo, 
      meta: {requiresAuth:true }
    },  {
      path:'/stuInfoing', 
      name:'stuInfoing', 
      component:stuInfoing, 
      meta: {requiresAuth:true }
    }
  ]
})



router.beforeEach((to, from, next) =>  {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (sessionStorage.getItem('stuInfo') == null) {
      next( {path:'/'})
    }else {
      next()
    }
  }else {
    next()// 确保一定要调用 next()
}
}); 

export default router; 


// WEBPACK FOOTER //
// ./src/router/index.js